<script lang="ts">
  import Header from '../components/layout/Header.svelte';
  import Footer from '../components/layout/Footer.svelte';
</script>

<div class="relative flex h-auto min-h-screen w-full flex-col overflow-x-hidden">
  <Header />

  <main class="flex-1 flex flex-col items-center w-full py-8 px-4 md:px-10">
    <div class="max-w-[780px] w-full flex flex-col gap-8">
      <!-- Page Title -->
      <div class="flex flex-col gap-2 pb-6 border-b border-gray-200/60">
        <div class="flex items-center gap-2 text-sm">
          <a href="/" class="text-[#617589] hover:underline">Home</a>
          <span class="text-[#617589]">/</span>
          <span class="text-[#111418] font-medium">Terms of Service</span>
        </div>
        <h1 class="text-[#111418] text-3xl md:text-4xl font-black leading-tight tracking-[-0.033em]">Terms of Service</h1>
        <p class="text-[#617589] text-base font-normal leading-normal">Last updated: February 3, 2026</p>
      </div>

      <!-- Content -->
      <div class="flex flex-col gap-6 text-[#111418] text-base leading-relaxed">

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">1. Acceptance of Terms</h2>
          <p class="text-[#617589]">
            By accessing or using EazyCalculators, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the platform.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">2. About EazyCalculators</h2>
          <p class="text-[#617589]">
            EazyCalculators is a free, browser-based platform providing a variety of calculators for personal and informational use. No account, registration, or payment is required. All calculations are performed locally in your browser.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">3. Use of the Service</h2>
          <p class="text-[#617589]">You agree to use EazyCalculators only for lawful purposes and in a manner that does not infringe upon the rights of others. You must not:</p>
          <ul class="list-disc list-inside text-[#617589] ml-2 flex flex-col gap-1">
            <li>Attempt to reverse-engineer, decompile, or tamper with the platform</li>
            <li>Use the service to generate fraudulent or misleading financial information</li>
            <li>Deploy automated scripts or bots to scrape or abuse the service</li>
            <li>Interfere with or disrupt the service or its infrastructure</li>
          </ul>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">4. Accuracy and Disclaimer</h2>
          <p class="text-[#617589]">
            EazyCalculators provides estimates based on the inputs you supply. Results are intended for informational and educational purposes only and do not constitute financial, tax, legal, or professional advice. Actual results may vary depending on your specific circumstances.
          </p>
          <p class="text-[#617589] mt-1">
            We make no guarantees regarding the accuracy or completeness of any calculation. You should always consult a qualified professional before making financial decisions.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">5. Intellectual Property</h2>
          <p class="text-[#617589]">
            All content on EazyCalculators — including text, code, design, and branding — is the intellectual property of EazyCalculators and is protected by applicable laws. You may not reproduce, distribute, or create derivative works without prior written permission.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">6. No Warranty</h2>
          <p class="text-[#617589]">
            EazyCalculators is provided on an "as is" and "as available" basis without any warranties of any kind, either express or implied. We do not warrant that the service will be uninterrupted, error-free, or free of viruses or other harmful components.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">7. Limitation of Liability</h2>
          <p class="text-[#617589]">
            To the fullest extent permitted by applicable law, EazyCalculators shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of or inability to use the service — including but not limited to loss of profits, data, or goodwill.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">8. Termination</h2>
          <p class="text-[#617589]">
            We reserve the right to suspend or discontinue access to EazyCalculators at any time, for any reason, without notice. Since no accounts or stored data are involved, termination has no further obligations on either party.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">9. Governing Law</h2>
          <p class="text-[#617589]">
            These Terms of Service shall be governed by and construed in accordance with the laws of the State of Delaware, United States, without regard to its conflict-of-law principles.
          </p>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-xl font-bold">10. Changes to These Terms</h2>
          <p class="text-[#617589]">
            We reserve the right to modify these Terms of Service at any time. Changes will be reflected by updating the date at the top of this page. Continued use of EazyCalculators after any change constitutes acceptance of the updated terms.
          </p>
        </section>

<!--        <section class="flex flex-col gap-2">-->
<!--          <h2 class="text-xl font-bold">11. Contact Us</h2>-->
<!--          <p class="text-[#617589]">-->
<!--            If you have questions about these Terms of Service, please contact us at <span class="text-primary">support@eazycalculators.net</span>.-->
<!--          </p>-->
<!--        </section>-->

      </div>
    </div>
  </main>

  <Footer />
</div>
